import React from 'react'
import { LucideIcon } from 'lucide-react'

interface ContentCardProps {
  title: string
  subtitle?: string
  icon?: LucideIcon
  children: React.ReactNode
  className?: string
}

const ContentCard: React.FC<ContentCardProps> = ({
  title,
  subtitle,
  icon: Icon,
  children,
  className = ''
}) => {
  return (
    <div
      className={`rounded-lg border p-6 ${className}`}
      style={{
        backgroundColor: 'var(--bg-secondary)',
        borderColor: 'var(--border-primary)'
      }}
    >
      <div className="flex items-center space-x-3 mb-4">
        {Icon && (
          <Icon className="h-6 w-6" style={{ color: 'var(--primary)' }} />
        )}
        <div>
          <h3 className="text-lg font-semibold" style={{ color: 'var(--text-primary)' }}>
            {title}
          </h3>
          {subtitle && (
            <p className="text-sm" style={{ color: 'var(--text-secondary)' }}>
              {subtitle}
            </p>
          )}
        </div>
      </div>
      <div>
        {children}
      </div>
    </div>
  )
}

export default ContentCard
